app.backToTop = {

	init: function() {

		app.backToTop.setEvents();
		
	},

	setEvents: function() {

		app.settings.$document.on('click', '.back-to-top', function(e){
			e.preventDefault();

			$('html, body').animate({
				scrollTop: 0
			}, 100);
		});

	}
};